import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  template: `
    @if (data.showCheckbox) {
      <div class="checkbox-container">
        <nb-checkbox [checked]="data.selected" (checkedChange)="toggle($event)"></nb-checkbox>
      </div>
    }
    `,
  styleUrls: ['./checkbox-cell.component.scss'],
})
export class CheckboxCellComponent {
  @Input()
  data: any;

  constructor() { }

  toggle(checked: boolean) {
    if (this.data?.action) {
      this.data.action(checked, this.data.id);
    }
  }
}
